import { Component, OnInit, OnDestroy, Output, EventEmitter, HostListener, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { EfemeridesService } from 'src/app/service/efemerides/efemerides.service';
import { Efemeride } from 'src/app/modal/efemerides/efemerides-response';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-efemerides',
  templateUrl: './efemerides.component.html',
  styleUrls: ['./efemerides.component.scss']
})
export class EfemeridesComponent implements OnInit, OnDestroy {

  @Output() efemeridesVacias = new EventEmitter<boolean>();
  @ViewChild('mobileCarousel', { static: false }) mobileCarousel: any;

  efemerides: Efemeride[] = [];
  todasLasEfemerides: Efemeride[] = []; // Guardar todas las efemérides cargadas
  selectedItem = 0;
  activeSlideIndex = 0;
  cargando = true;
  mostrarCalendario = false;
  esFechaFiltrada = false; // Indicador de si estamos mostrando resultados filtrados

  // Variables para el swipe táctil
  private touchStartX: number = 0;
  private touchEndX: number = 0;
  private touchStartY: number = 0;
  private touchEndY: number = 0;
  private minSwipeDistance: number = 50; // Distancia mínima para considerar un swipe

  // Para imágenes protegidas
  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  private imageUrlCache: Map<string, string | null> = new Map();
  private imageLoadStartTimes: Map<string, number> = new Map();
  public isSkeletonVisible: Map<string, boolean> = new Map();

  // Para margen dinámico
  fixedContainerHeight: number = 0;

  // Para el slider
  currentSlide: number = 0;
  itemsPerSlide: number = 3;
  slideGroups: Efemeride[][] = [];
  private autoSlideInterval: any;

  // Para la fecha actual
  fechaActual: string = '';

  // Fecha seleccionada en el calendario (para preservar estado)
  calendarioFechaSeleccionada: { dia: number, mes: number } | null = null;

  // Menú de compartir
  mostrarShareMenu: boolean = false;

  constructor(
    private efemeridesService: EfemeridesService,
    private protectedImageService: ProtectedImageService,
    private renderer: Renderer2,
    private el: ElementRef,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.obtenerFechaActual();
    this.cargarEfemerides();
    this.updateMargin();
  }

  ngOnDestroy(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (this.mostrarShareMenu && !target.closest('.share-menu-wrapper')) {
      this.mostrarShareMenu = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.updateMargin();
  }

  private obtenerFechaActual(): void {
    const meses = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    const hoy = new Date();
    const dia = hoy.getDate();
    const mes = meses[hoy.getMonth()];

    this.fechaActual = `${dia} de ${mes}`;
  }

  private updateMargin(): void {
    setTimeout(() => {
      const fixedContainer = document.querySelector('.fixed-submenus') as HTMLElement;
      if (fixedContainer) {
        this.fixedContainerHeight = fixedContainer.offsetHeight;

        const contentContainer = this.el.nativeElement.querySelector('.efemerides-container') as HTMLElement;
        if (contentContainer) {
          //this.renderer.setStyle(contentContainer, 'margin-top', `${this.fixedContainerHeight}px`);
        }

        const contentContainerM = this.el.nativeElement.querySelector('.efemerides-container-m') as HTMLElement;
        if (contentContainerM) {
          //this.renderer.setStyle(contentContainerM, 'margin-top', `${this.fixedContainerHeight}px`);
        }
      }
    }, 0);
  }

  cargarEfemerides() {
    this.efemeridesService.obtenerEfemerides().subscribe(
      response => {
        if (response && response.response && response.response.list && response.response.list.length > 0) {
          this.mostrarEfemeridesResultado(response.response.list, false);
        } else {
          // No hay efemérides para hoy, buscar en días anteriores
          this.buscarEfemeridesDiasAnteriores(1);
        }
      },
      error => {
        console.error('Error al cargar efemérides:', error);
        // En caso de error, intentar días anteriores también
        this.buscarEfemeridesDiasAnteriores(1);
      }
    );
  }

  /**
   * Busca efemérides en días anteriores cuando hoy no tiene resultados.
   * Retrocede hasta MAX_DIAS_ATRAS días.
   */
  private readonly MAX_DIAS_ATRAS = 7;

  private buscarEfemeridesDiasAnteriores(diasAtras: number): void {
    if (diasAtras > this.MAX_DIAS_ATRAS) {
      // Se agotaron los intentos, mostrar banner antiguo
      this.efemeridesVacias.emit(true);
      this.cargando = false;
      return;
    }

    const fecha = new Date();
    fecha.setDate(fecha.getDate() - diasAtras);
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;

    this.efemeridesService.obtenerEfemeriadesPorFecha(dia, mes).subscribe(
      response => {
        if (response && response.response && response.response.list && response.response.list.length > 0) {
          // Encontró efemérides, actualizar la fecha mostrada
          const meses = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
          ];
          this.fechaActual = `${dia} de ${meses[mes - 1]}`;
          this.esFechaFiltrada = true;
          this.mostrarEfemeridesResultado(response.response.list, true);
        } else {
          // Seguir buscando un día más atrás
          this.buscarEfemeridesDiasAnteriores(diasAtras + 1);
        }
      },
      error => {
        // En caso de error, seguir intentando
        this.buscarEfemeridesDiasAnteriores(diasAtras + 1);
      }
    );
  }

  /**
   * Procesa y muestra las efemérides encontradas
   */
  private mostrarEfemeridesResultado(list: Efemeride[], esFallback: boolean): void {
    this.efemerides = list;
    this.todasLasEfemerides = [...list];

    // Calcular los grupos para el slider una sola vez
    this.calculateSlideGroups();

    // Cargar imágenes protegidas para todas las efemérides
    this.efemerides.forEach(efemeride => {
      if (efemeride.activoId) {
        this.loadProtectedThumbnail(efemeride.activoId);
      }
    });

    this.efemeridesVacias.emit(false);
    this.cargando = false;
  }

  private calculateSlideGroups(): void {
    this.slideGroups = [];
    for (let i = 0; i < this.efemerides.length; i += this.itemsPerSlide) {
      this.slideGroups.push(this.efemerides.slice(i, i + this.itemsPerSlide));
    }

    // Resetear a la primera página/slide (versión web)
    this.currentSlide = 0;

    // Resetear carrusel móvil a la primera slide
    this.activeSlideIndex = 0;
    if (this.mobileCarousel) {
      setTimeout(() => {
        this.mobileCarousel.selectSlide(0);
      }, 100);
    }

    // Iniciar el auto-slide solo si hay más de un grupo
    if (this.slideGroups.length > 1) {
      this.startAutoSlide();
    }
  }

  private startAutoSlide(): void {
    // Limpiar intervalo existente si lo hay
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }

    // Iniciar nuevo intervalo - cambiar cada 5 segundos (5000ms)
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  private resetAutoSlide(): void {
    // Reiniciar el intervalo cuando el usuario interactúa manualmente
    this.startAutoSlide();
  }

  pauseAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
      this.autoSlideInterval = null;
    }
  }

  resumeAutoSlide(): void {
    if (this.slideGroups.length > 1) {
      this.startAutoSlide();
    }
  }

  loadProtectedThumbnail(imageId: string, forceReload: boolean = false): void {
    if (!imageId) {
      return;
    }

    // Si no es recarga forzada y ya existe, no recargar
    if (!forceReload && this.protectedImages.has(imageId)) {
      return;
    }

    // Marcar como cargando
    this.protectedImages.set(imageId, {
      imageId: imageId,
      protectedThumbnailUrl: null,
      expiresIn: 0,
      loadedAt: Date.now()
    });

    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now();
        this.protectedImages.set(imageId, response);
        this.imageUrlCache.set(imageId, response.protectedThumbnailUrl);

        if (!this.imageLoadStartTimes.has(imageId)) {
          this.imageLoadStartTimes.set(imageId, Date.now());
        }
      },
      error: (error) => {
        console.error('Error cargando imagen protegida:', imageId, error);
        this.protectedImages.delete(imageId);
        this.imageUrlCache.delete(imageId);
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    if (!imageId) {
      return null;
    }

    return this.imageUrlCache.get(imageId) || null;
  }

  shouldShowSkeleton(imageId: string): boolean {
    if (!imageId) {
      return false;
    }

    const url = this.imageUrlCache.get(imageId);
    if (!url) {
      return true;
    }

    return this.isSkeletonVisible.get(imageId) || false;
  }

  onSlideChange(index: number) {
    this.selectedItem = index;
  }

  changeSlide(index: number) {
    this.activeSlideIndex = index;
  }

  moveToPrevSlide() {
    if (this.activeSlideIndex > 0) {
      this.activeSlideIndex--;
    } else {
      this.activeSlideIndex = this.efemerides.length - 1;
    }
  }

  moveToNextSlide() {
    if (this.activeSlideIndex < this.efemerides.length - 1) {
      this.activeSlideIndex++;
    } else {
      this.activeSlideIndex = 0;
    }
  }

  // Métodos para el slider de 3 en 3
  nextSlide(): void {
    if (this.currentSlide < this.slideGroups.length - 1) {
      this.currentSlide++;
    } else {
      this.currentSlide = 0;
    }
  }

  prevSlide(): void {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    } else {
      this.currentSlide = this.slideGroups.length - 1;
    }
    this.resetAutoSlide();
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.resetAutoSlide();
  }

  onPrevClick(): void {
    this.prevSlide();
  }

  onNextClick(): void {
    this.nextSlide();
    this.resetAutoSlide();
  }

  /**
   * Genera un slug amigable desde el título
   */
  generateSlug(title: string): string {
    if (!title) return 'd';

    return title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
      .replace(/[^a-z0-9\s-]/g, '') // Eliminar caracteres especiales
      .trim()
      .replace(/\s+/g, '-') // Reemplazar espacios con guiones
      .replace(/-+/g, '-') // Reemplazar múltiples guiones con uno solo
      .substring(0, 100) || 'd'; // Limitar longitud y fallback
  }

  /**
   * Obtiene la ruta de navegación según la categoría
   */
  getRouterLink(efemeride: Efemeride): string[] {
    const slug = efemeride.titleShowUrl || this.generateSlug(efemeride.titulo);

    // Si tiene categoryName, usarlo para determinar la ruta
    if (efemeride.categoryName === 'PORTADAS_HISTORICAS') {
      return ['/dtp', slug, efemeride.id];
    } else {
      // Por defecto, usar /dt (FOTOGRAFIAS u otros)
      return ['/dt', slug, efemeride.id];
    }
  }

  /**
   * Calcula cuántos años han pasado desde la efeméride
   */
  getYearsAgo(anio: number): number {
    const currentYear = new Date().getFullYear();
    return currentYear - anio;
  }

  /**
   * Devuelve el texto formateado "Hace X años"
   */
  getYearsAgoText(anio: number): string {
    const years = this.getYearsAgo(anio);

    if (years === 0) {
      return 'Este año';
    } else if (years === 1) {
      return 'Hace 1 año';
    } else {
      return `Hace ${years} años`;
    }
  }

  /**
   * Manejo de eventos táctiles para swipe
   */
  onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
  }

  onTouchMove(event: TouchEvent): void {
    this.touchEndX = event.changedTouches[0].screenX;
    this.touchEndY = event.changedTouches[0].screenY;
  }

  onTouchEnd(event: TouchEvent): void {
    this.handleSwipe();
  }

  private handleSwipe(): void {
    const horizontalDistance = this.touchEndX - this.touchStartX;
    const verticalDistance = Math.abs(this.touchEndY - this.touchStartY);

    // Solo procesar si el movimiento horizontal es mayor que el vertical
    // Esto evita conflictos con el scroll vertical
    if (Math.abs(horizontalDistance) > verticalDistance) {
      // Swipe hacia la izquierda (siguiente slide)
      if (horizontalDistance < -this.minSwipeDistance) {
        this.nextSlideMobile();
      }
      // Swipe hacia la derecha (slide anterior)
      else if (horizontalDistance > this.minSwipeDistance) {
        this.prevSlideMobile();
      }
    }

    // Resetear valores
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.touchStartY = 0;
    this.touchEndY = 0;
  }

  /**
   * Ir al siguiente slide en móvil
   */
  private nextSlideMobile(): void {
    if (this.mobileCarousel && this.mobileCarousel.activeSlide < this.efemerides.length - 1) {
      this.mobileCarousel.nextSlide();
    } else if (this.mobileCarousel) {
      // Volver al primer slide si estamos en el último
      this.mobileCarousel.selectSlide(0);
    }
  }

  /**
   * Ir al slide anterior en móvil
   */
  private prevSlideMobile(): void {
    if (this.mobileCarousel && this.mobileCarousel.activeSlide > 0) {
      this.mobileCarousel.previousSlide();
    } else if (this.mobileCarousel) {
      // Ir al último slide si estamos en el primero
      this.mobileCarousel.selectSlide(this.efemerides.length - 1);
    }
  }

  /**
   * Genera el mensaje personalizado para compartir en redes sociales
   */
  private generarMensajeCompartir(efemeride: Efemeride): string {
    const yearsAgo = this.getYearsAgoText(Number(efemeride.anio));
    const fecha = `${efemeride.dia}/${efemeride.mes}/${efemeride.anio}`;

    // Determinar el texto del encabezado según si es fecha actual o búsqueda
    const encabezado = this.esFechaFiltrada
      ? `📅 Un día como el ${this.fechaActual}`
      : `📅 Un día como hoy, ${this.fechaActual}`;

    // Recortar descripción de forma inteligente (en una palabra completa)
    let descripcionCorta = efemeride.descripcion;
    if (descripcionCorta.length > 120) {
      descripcionCorta = descripcionCorta.substring(0, 120);
      const ultimoEspacio = descripcionCorta.lastIndexOf(' ');
      if (ultimoEspacio > 0) {
        descripcionCorta = descripcionCorta.substring(0, ultimoEspacio);
      }
      descripcionCorta += '...';
    }

    // Mensaje personalizado más ordenado
    const mensaje = `${encabezado}
${yearsAgo}: ${efemeride.titulo}

${descripcionCorta}

🔍 Descubre más en el Archivo Histórico del Diario Oficial El Peruano`;

    return mensaje;
  }

  /**
   * Obtiene la URL completa de la efeméride
   */
  private obtenerUrlEfemeride(efemeride: Efemeride): string {
    const routerLink = this.getRouterLink(efemeride);
    const baseUrl = window.location.origin;
    return `${baseUrl}${routerLink.join('/')}`;
  }

  /**
   * Compartir en Facebook
   */
  sharedFacebook(efemeride: Efemeride): void {
    const url = this.obtenerUrlEfemeride(efemeride);
    const urlShared = `http://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(urlShared, "_blank");
  }

  /**
   * Compartir en WhatsApp
   */
  sharedWhatsapp(efemeride: Efemeride): void {
    const url = this.obtenerUrlEfemeride(efemeride);
    const mensaje = this.generarMensajeCompartir(efemeride);
    const textoCompleto = `${mensaje} ${url}`;
    const urlShared = `https://api.whatsapp.com/send?text=${encodeURIComponent(textoCompleto)}`;
    window.open(urlShared, "_blank");
  }

  /**
   * Compartir en Twitter
   */
  sharedTwitter(efemeride: Efemeride): void {
    const url = this.obtenerUrlEfemeride(efemeride);
    const mensaje = this.generarMensajeCompartir(efemeride);
    const urlShared = `https://twitter.com/intent/tweet?text=${encodeURIComponent(mensaje)}&url=${encodeURIComponent(url)}`;
    window.open(urlShared, "_blank");
  }

  /**
   * Toggle del menú de compartir
   */
  toggleShareMenu(): void {
    this.mostrarShareMenu = !this.mostrarShareMenu;
    if (this.mostrarShareMenu) {
      this.mostrarCalendario = false;
    }
  }

  /**
   * Genera el mensaje resumen agrupado de efemérides
   */
  private generarMensajeResumen(): string {
    const fecha = this.esFechaFiltrada
      ? `el ${this.fechaActual}`
      : `hoy, ${this.fechaActual}`;

    const grupos = new Map<string, number>();
    this.efemerides.forEach(ef => {
      const titulo = ef.titulo || 'Sin título';
      grupos.set(titulo, (grupos.get(titulo) || 0) + 1);
    });

    const listado = Array.from(grupos.entries())
      .map(([titulo, cantidad]) => {
        const fotos = cantidad.toString().padStart(2, '0');
        return `- ${fotos} ${cantidad === 1 ? 'foto' : 'fotos'} — ${titulo}`;
      })
      .join('\n');

    return `Mira estas imágenes del Archivo Histórico del Diario Oficial El Peruano... un día como ${fecha}:\n\n${listado}`;
  }

  /**
   * Compartir resumen por WhatsApp
   */
  compartirResumenWhatsapp(): void {
    const mensaje = `${this.generarMensajeResumen()}\n\n🔍 Descubre más en: ${window.location.origin}`;
    const urlShared = `https://api.whatsapp.com/send?text=${encodeURIComponent(mensaje)}`;
    window.open(urlShared, '_blank');
    this.mostrarShareMenu = false;
  }

  /**
   * Compartir resumen por Facebook
   */
  compartirResumenFacebook(): void {
    const urlShared = `http://www.facebook.com/sharer.php?u=${encodeURIComponent(window.location.origin)}&quote=${encodeURIComponent(this.generarMensajeResumen())}`;
    window.open(urlShared, '_blank');
    this.mostrarShareMenu = false;
  }

  /**
   * Compartir resumen por X (Twitter)
   */
  compartirResumenTwitter(): void {
    const mensaje = this.generarMensajeResumen();
    const urlShared = `https://twitter.com/intent/tweet?text=${encodeURIComponent(mensaje)}&url=${encodeURIComponent(window.location.origin)}`;
    window.open(urlShared, '_blank');
    this.mostrarShareMenu = false;
  }

  /**
   * Toggle del calendario
   */
  toggleCalendario(): void {
    this.mostrarCalendario = !this.mostrarCalendario;
    if (this.mostrarCalendario) {
      this.mostrarShareMenu = false;
    }
  }

  /**
   * Limpia el caché de imágenes protegidas
   * Útil cuando se quiere forzar la recarga de todas las imágenes con JWTs nuevos
   */
  private limpiarCacheImagenes(): void {
    // console.log('Limpiando caché de imágenes protegidas...');
    this.protectedImages.clear();
    this.imageUrlCache.clear();
    this.imageLoadStartTimes.clear();
    this.isSkeletonVisible.clear();
  }

  /**
   * Manejar selección de fecha del calendario
   */
  onFechaSeleccionada(fecha: { dia: number, mes: number }): void {
    // Guardar la fecha seleccionada para preservar estado del calendario
    this.calendarioFechaSeleccionada = fecha;

    // Verificar si la fecha seleccionada es HOY
    const hoy = new Date();
    const esHoy = fecha.dia === hoy.getDate() && fecha.mes === (hoy.getMonth() + 1);

    // Limpiar caché de imágenes para forzar la generación de nuevos JWTs
    this.limpiarCacheImagenes();

    // Buscar efemérides por fecha usando el backend (SP_SEARCH_EFEMERIDES)
    this.cargando = true;
    this.efemeridesService.obtenerEfemeriadesPorFecha(fecha.dia, fecha.mes).subscribe(
      response => {
        if (response && response.response && response.response.list && response.response.list.length > 0) {
          this.efemerides = response.response.list;
          this.esFechaFiltrada = !esHoy; // Solo marcar como filtrada si NO es hoy

          // Recalcular los grupos para el slider
          this.calculateSlideGroups();

          // Cargar TODAS las imágenes con JWTs nuevos (10 segundos frescos)
          this.efemerides.forEach(efemeride => {
            if (efemeride.activoId) {
              this.loadProtectedThumbnail(efemeride.activoId, true);
            }
          });

          this.efemeridesVacias.emit(false);

          // Actualizar la fecha mostrada
          const meses = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
          ];
          this.fechaActual = `${fecha.dia} de ${meses[fecha.mes - 1]}`;

          // Cerrar el calendario después de seleccionar
          this.mostrarCalendario = false;
        } else {
          // No hay efemérides para la fecha buscada
          if (esHoy) {
            // Si es HOY y no hay efemérides, mostrar mensaje de vacío
            this.efemeridesVacias.emit(true);
            this.toastr.info(
              'No hay efemérides registradas para el día de hoy',
              'Sin resultados',
              {
                timeOut: 4000,
                positionClass: 'toast-top-right'
              }
            );
          } else {
            // Si es una búsqueda y no hay resultados, hacer fallback a HOY
            this.toastr.info(
              `No hay efemérides registradas para el ${fecha.dia} de ${this.obtenerNombreMes(fecha.mes)}. Mostrando efemérides de hoy.`,
              'Sin resultados',
              {
                timeOut: 5000,
                positionClass: 'toast-top-right'
              }
            );

            // Cerrar calendario y recargar efemérides de hoy
            this.mostrarCalendario = false;
            this.esFechaFiltrada = false;
            this.obtenerFechaActual();
            this.cargarEfemerides();
            return; // Salir para evitar poner cargando en false
          }
        }
        this.cargando = false;
      },
      error => {
        console.error('Error al buscar efemérides por fecha:', error);

        if (esHoy) {
          // Si es HOY y hay error, mostrar banner de vacío
          this.toastr.error(
            'Error al cargar las efemérides del día de hoy',
            'Error',
            {
              timeOut: 4000,
              positionClass: 'toast-top-right'
            }
          );
          this.efemeridesVacias.emit(true);
        } else {
          // Si es búsqueda y hay error, hacer fallback a HOY
          this.toastr.error(
            `Error al buscar efemérides para el ${fecha.dia} de ${this.obtenerNombreMes(fecha.mes)}. Mostrando efemérides de hoy.`,
            'Error',
            {
              timeOut: 5000,
              positionClass: 'toast-top-right'
            }
          );

          this.mostrarCalendario = false;
          this.esFechaFiltrada = false;
          this.obtenerFechaActual();
          this.cargarEfemerides();
          return;
        }

        this.cargando = false;
      }
    );
  }

  /**
   * Obtener nombre del mes
   */
  private obtenerNombreMes(mes: number): string {
    const meses = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    return meses[mes - 1] || '';
  }

}
